import { defineMessages } from 'react-intl';

export default defineMessages({
  loading: {
    id: 'baukasten.LoadingSpinner.loading',
    defaultMessage: 'Loading',
  },
});
